<app-input-label [inputId]="id" [inputName]="name" [mandatory]="mandatory"></app-input-label>

<div class="inputs-container" [class.horizontal]="displayHorizontally">
  <ng-container *ngFor="let option of options; let i = index">
    <div
      class="input-container"
      [class.margin-bottom]="!displayHorizontally"
      [class.margin-right]="displayHorizontally && !isLastItem(options, i)"
    >
      <input
        class="input"
        [class.disabled]="isDisabled"
        type="radio"
        [id]="id + option"
        [name]="name"
        [value]="option"
        [checked]="checked(option)"
        [disabled]="isDisabled"
        (click)="handleInput(option)"
      >

      <label class="label" [class.disabled]="isDisabled" [for]="id + option">{{ option }}</label>
    </div>
  </ng-container>
</div>
